import * as React from 'react';
import type { SVGProps } from 'react';

const SvgLargeXIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <path
      fill="currentColor"
      d="M.504.504a1.714 1.714 0 0 1 2.426 0L12 9.577 21.07.504a1.715 1.715 0 1 1 2.427 2.426L14.424 12l9.073 9.07a1.717 1.717 0 0 1-2.427 2.427L12 14.424l-9.07 9.073a1.718 1.718 0 0 1-2.798-.556 1.716 1.716 0 0 1 .372-1.87L9.577 12 .504 2.93a1.714 1.714 0 0 1 0-2.427Z"
    />
  </svg>
);
export default SvgLargeXIcon;
